// extracted by mini-css-extract-plugin
module.exports = {"postfix":"Postfix_postfix__s8rNw"};